import { render, staticRenderFns } from "./envio-mail.vue?vue&type=template&id=1f8054e0&scoped=true"
import script from "./envio-mail.vue?vue&type=script&lang=js"
export * from "./envio-mail.vue?vue&type=script&lang=js"
import style0 from "./envio-mail.vue?vue&type=style&index=0&id=1f8054e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8054e0",
  null
  
)

export default component.exports